module.exports = __webpack_public_path__ + "img/bc_arthritis_fast_pain_relief_powder_packs.11487221.jpg";